// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3QpOf","buttons":"PendingPaymentAlert_buttons__3bBVe"};